import { render, staticRenderFns } from "./alert_detail_body.vue?vue&type=template&id=49a96a92&scoped=true&"
import script from "./alert_detail_body.vue?vue&type=script&lang=js&"
export * from "./alert_detail_body.vue?vue&type=script&lang=js&"
import style0 from "./alert_detail_body.vue?vue&type=style&index=0&id=49a96a92&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49a96a92",
  null
  
)

export default component.exports